export const ERROR_LOAD_FILE_OUTSIDE_BROWSER =
  "Direct raster loading is currently not supported outside of the browser due to dependency limitations. Please use either a url or run the code in the browser.";

export const ERROR_BAD_URL =
  "GeoBlaze could not load the file. This is usually because the url is incorrect or the website's security prevents cross domain requests. Try again or download the file and load it manually.";

export const ERROR_PARSING_GEOTIFF = "GeoBlaze had a problem parsing this file. Please make sure that you are sending a proper GeoTIFF file and try again.";
